module.exports = __webpack_public_path__ + "img/14_23.1d2ce93e.png";